import { Box, TableContainer, Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { USER_SERVER } from "./constants";

const PersonalPricingTable = () => {
  return (
    <Box id="pricing">
      <TableContainer>
        <Table variant="striped" border="2px solid rgb(237,242,247)">
          <Thead>
            <Tr>
              <Th textAlign={"center"}>CPU</Th>
              <Th textAlign={"center"}>Memory</Th>
              <Th textAlign={"center"}>User Disk</Th>
              <Th colSpan={2} textAlign={"center"} border="2px solid #EDF2F7">
                Pricing
              </Th>
            </Tr>
            <Tr>
              <Th></Th>
              <Th></Th>
              <Th></Th>
              <Th textAlign={"center"} border="2px solid #EDF2F7">
                Linux
              </Th>{" "}
              <Th textAlign={"center"} border="2px solid #EDF2F7">
                Windows
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {USER_SERVER.map((server, index) => (
              <Tr key={index}>
                <Td textAlign={"center"}>{server.cpu}</Td>
                <Td textAlign={"center"}>{server.memory}</Td>
                <Td textAlign={"center"}>{server.user_disk}</Td>
                <Td textAlign={"center"}>{server.pricing.linux}</Td>
                <Td textAlign={"center"}>{server.pricing.windows}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PersonalPricingTable;
